import { ReactNode } from "react";
import { createFastContext } from "../../contexts/createFastContext";
import { datetime } from "../../util/library/datetime2";
import { VESSEL_TYPE } from "../../util/varibles/constants";
import { FleetUtilizationItem } from "../../util/varibles/interface";

export type TVesselOverviewView = "month" | "year";
export type TVesselInsightMetric = "operation" | "hygine" | "maintenance" | "idle" | "travelling";
export type TVesselInsightOperator = "<" | ">" | "=";

export interface IVesselInsightFilter {
    metric: TVesselInsightMetric;
    operator: TVesselInsightOperator;
    value?: number;
}

export function getCurrentDuration(view: TVesselOverviewView): [number, number] {
    const now = datetime();

    return [
        now.startOf(view).valueOf(),
        now.valueOf(),
    ];
}

interface IState {
    activeView: TVesselOverviewView;
    duration: [number, number];
    loadingVesselIds: string[];
    sumary: FleetUtilizationItem[];
    search: string;
    vesselFilter: string[];
    vesselTypeFilter: VESSEL_TYPE[];
    insightFilters: IVesselInsightFilter[];
    appliedInsightFilters: IVesselInsightFilter[];
}

const {
    Provider,
    useStore: useVesselOverview,
    setStore: setVesselOverview,
    getStore: getVesselOverview,
} = createFastContext<IState>({
    activeView: "month",
    duration: getCurrentDuration('month'),
    loadingVesselIds: [],
    sumary: [],
    search: "",
    vesselFilter: [],
    vesselTypeFilter: [],
    insightFilters: [],
    appliedInsightFilters: [],
});

const VesselOverviewProvider = ({
    children,
    ...props
}: { children: ReactNode } & Partial<IState>) => {
    return <Provider props={props}>{children}</Provider>;
};

export {
    getVesselOverview,
    setVesselOverview,
    useVesselOverview,
    VesselOverviewProvider,
};
